export default class Case {
  constructor({ express = '', components }) {
    this.express = express;
    this.components = components;
  }
}
